jQuery(document).ready(($) => {
    'use strict';

    if (!window.kilamobler_add_to_cart_params) {
        return;
    }

    const templates = {
        price: wp.template('woocommerce-price'),
    };

    function showMessageToCustomer(topic, message, type) {
        if (swal && swal.fire) {
            swal.fire(topic, message, type);
        } else {
            typeof swal === 'function' && swal(topic, message, type);
        }
    }

    function formatPrice(price) {
        const format = window.kilamobler_add_to_cart_params.price_format;
        const symbol = window.kilamobler_add_to_cart_params.currency_symbol;
        const thousandsSeparator = window.kilamobler_add_to_cart_params.currency_thousands_separator;
        const decimals = window.kilamobler_add_to_cart_params.currency_decimals;
        const decimalsSeparator = window.kilamobler_add_to_cart_params.currency_decimals_separator;

        price = round(
            price,
            window.kilamobler_add_to_cart_params.currency_rounding_settings,
        )
            .toFixed(decimals)
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousandsSeparator)
            .replace('.', decimalsSeparator)
            .replace(`${decimalsSeparator}00`, '');
        return format
            .replace(
                '%1$s',
                `<span class="woocommerce-Price-currencySymbol">${symbol}</span>`,
            )
            .replace('%2$s', price);
    }

    function round(price, settings) {
        if (settings != null) {
            const {type, value, subtract} = settings;

            switch (type) {
                case 'up':
                    price = Math.ceil(price / value) * value - subtract;
                    break;
                case 'down':
                    price = Math.floor(price / value) * value - subtract;
                    break;
                case 'nearest':
                    price = Math.round(price / value) * value - subtract;
                    break;
                default:
                    break;
            }
        }

        return price;
    }

    function replaceProductPrices(regularPrice, price, msrp) {
        const $result = templates.price({
            regular_price: regularPrice > 0
                ? formatPrice(regularPrice)
                : formatPrice(price),
            price: formatPrice(price),
            msrp_price: msrp > 0 && price !== msrp && regularPrice !== msrp
                ? formatPrice(msrp)
                : null,
        });

        $('.js--replace-price').empty().append($result);

        if ($('.sp-flyout.visible').length) {
            setTimeout(function() {
                $('.js--replace-price').addClass('price-higlighted');
            }, 1000);

            setTimeout(function() {
                $('.js--replace-price').removeClass('price-higlighted');
            }, 1800);
        } else {
            $('.js--replace-price').addClass('price-higlighted');
            setTimeout(function() {
                $('.js--replace-price').removeClass('price-higlighted');
            }, 800);
        }
    }

    function convertGa4EventToGa3(event) {
        return {
            event: 'gtm4wp.addProductToCartEEC',
            ecommerce: {
                currencyCode: 'SEK',
                add: {
                    products: event.ecommerce.items.map(item => {
                        const product = {
                            brand: item.brand,
                            id: item.item_id,
                            category: item.item_category,
                            name: item.item_name,
                            price: item.price,
                            quantity: item.quantity,
                            stockLevel: '',
                        };

                        if (item.item_variant) {
                            product.variant = item.item_variant;
                        }

                        return product;
                    }),
                },
            },
        };
    }

    function trackAddToCartEvent(data) {
        const event = {
            event: 'add_to_cart',
            ecomm_pagetype: 'product',
            ecommerce: {
                currency: 'SEK',
                value: data.price,
                items: [
                    {
                        google_business_vertical: 'retail',
                        item_brand: data.gtm_item_brand,
                        item_category: data.gtm_item_category,
                        item_category2: data.gtm_item_category2,
                        item_category3: data.gtm_item_category3,
                        item_category4: data.gtm_item_category4,
                        item_id: data.gtm_item_id,
                        item_name: data.gtm_item_name,
                        price: data.price / (data.quantity || 1),
                        quantity: parseInt(data.quantity),
                    },
                ],
            },
        };

        if (data.variation) {
            event.ecommerce.items[0].item_variant = Object.values(
                data.variation.attributes,
            ).join(',');
        }

        if (window.dataLayer) {
            window.dataLayer.push(convertGa4EventToGa3(event));
            window.dataLayer.push(event);
        }
    }

    function trackLoop54AddToCartEvent(productId) {
        if (productId && window.kilamobler && window.kilamobler.loop) {
            window.kilamobler.loop.createEvent('addtocart', {type: 'Product', id: productId});
        }
    }

    (function() {
        $(document.body).on(
            'click',
            '.quantity .minus',
            e => onQuantityChange(-1, e),
        );

        $(document.body).on(
            'click',
            '.quantity .plus',
            e => onQuantityChange(1, e),
        );

        function onQuantityChange(modifier, e) {
            e.preventDefault();

            const $target = $(e.target);
            const $input = $target.parent().find('input[type="number"]');

            const min = $input.attr('min') || 1;
            const max = $input.attr('max') || 9007199254740991;

            const newValue = parseInt($input.val(), 10) + modifier;

            $input.val(newValue < min ? min : newValue > max ? max : newValue);

            $input.trigger('change');
        }
    }());

    class Add_To_Cart {
        drivers = [];

        constructor() {
            const actionBar = new Action_Bar();

            this.drivers.push(new Global_Driver());

            const productType = window.kilamobler_add_to_cart_params.product_type;
            if (productType !== 'none') {
                if (productType === 'composite') {
                    this.drivers.push(
                        new Composite_Driver(actionBar),
                    );
                } else {
                    this.drivers.push(
                        new WooCommerce_Driver(actionBar),
                    );
                }
            }
        }
    }

    class Action_Bar {
        listeners = [];

        constructor() {
            this.DOM = {
                $el: $('.action-bar'),
            };

            this.DOM.$title =
                this.DOM.$el.find('.title');
            this.DOM.$image =
                this.DOM.$el.find('.image');
            this.DOM.$link =
                this.DOM.$el.find('.link a');
            this.DOM.$quantity =
                this.DOM.$el.find('.quantity input[type="number"]');
            this.DOM.$button =
                this.DOM.$el.find('.add-to-cart');

            this.DOM.$link.on(
                'click',
                this.onLinkClick,
            );

            this.DOM.$quantity.on(
                'change',
                e => this.trigger('quantity/change', e),
            );

            this.DOM.$button.on(
                'click',
                e => this.trigger('button/click', e),
            );
        }

        setAddToCartDisabled = disabled => {
            this.DOM.$button.prop('disabled', disabled ? 'disabled' : '');
        };

        setAddToCartLoading = loading => {
            if (loading && !this.DOM.$button.hasClass('loading')) {
                this.DOM.$button.addClass('loading');
            } else if (!loading && this.DOM.$button.hasClass('loading')) {
                this.DOM.$button.removeClass('loading');
            }
        };

        onLinkClick = (e) => {
            e.preventDefault();

            $('html,body')
                .animate(
                    {scrollTop: $('.cart').offset().top - 100},
                    'slow',
                );
        };

        on = (event, callback) => {
            if (this.listeners[event] == null) {
                this.listeners[event] = [];
            }

            this.listeners[event].push(callback);
        };

        off = (event, callback) => {
            if (this.listeners[event] == null) {
                return;
            }

            this.listeners = this.listeners.filter(c => c !== callback);
        };

        trigger(event, ...data) {
            if (this.listeners[event] == null) {
                return;
            }

            for (let i = 0, l = this.listeners[event].length; i < l; ++i) {
                this.listeners[event][i](...data);
            }
        }
    }

    class Driver {
        constructor() {
            this.analyticsData = {};
        }

        addToCart = data => {
            const onSuccess = response => {
                if (!response) {
                    return;
                }

                if (response.error) {
                    let message = 'Något gick fel.';

                    if (response.messages) {
                        message = response.messages[0];
                    }

                    const topic = 'Kunde inte lägga till produkten i varukorgen.';
                    showMessageToCustomer(topic, message, 'error');
                } else {
                    window.dispatchEvent(new CustomEvent(
                        'mini-cart-refresh',
                        {detail: response.data},
                    ));

                    trackLoop54AddToCartEvent(data.get('add-to-cart'));

                    /*if (response.data && response.data.fragments) {
                     // Trigger event so themes can refresh other areas.
                     const payload = [
                     response.data.fragments,
                     response.data.cart_hash,
                     ];

                     $(document.body).trigger('added_to_cart', payload);
                     }*/
                }
            };

            const onError = () => showMessageToCustomer(
                'Något gick fel.',
                'Vi upplever just nu lite problem. Var vänlig försök igen senare.',
                'error',
            );

            trackAddToCartEvent({
                ...Object.fromEntries(data),
                price: this.price,
                variation: this.lastSelectedVariation,
            });

            const options = {
                type: 'POST',
                url: kilamobler_add_to_cart_params.ajax_url.toString()
                    .replace('%%endpoint%%', 'add-to-cart'),
                data: data,
                processData: false,
                contentType: false,
                dataType: 'json',
                responseType: 'json',
                cache: false,
            };

            return $.ajax(options).then(onSuccess, onError);
        };

        removeFromCart = cartItemKey => {
            const onSuccess = response => {
                if (!response) {
                    return;
                }

                if (response.error) {
                    let message = 'Något gick fel.';

                    if (response.messages) {
                        message = response.messages[0];
                    }

                    const topic = 'Kunde inte ta bort produkten från varukorgen.';
                    showMessageToCustomer(topic, message, 'error');
                } else {
                    window.dispatchEvent(new CustomEvent(
                        'mini-cart-refresh',
                        {detail: response.data},
                    ));
                }
            };

            const options = {
                type: 'post',
                url: kilamobler_add_to_cart_params.ajax_url.toString()
                    .replace('%%endpoint%%', 'remove-from-cart'),
                data: {
                    item: cartItemKey,
                },
            };

            return $.ajax(options).then(onSuccess);
        };
    }

    class Global_Driver extends Driver {
        constructor() {
            super();

            $(document.body).on(
                'click',
                '.remove_from_cart_button',
                this.onRemoveFromCart,
            );

            $(document.body).on(
                'click',
                '.single_add_to_cart_button',
                this.onQuickAddToCart,
            );
        }

        onRemoveFromCart = e => {
            e.preventDefault();

            const $target = $(e.target);
            const $item = $target.closest('.woocommerce-mini-cart-item');

            $item.block({
                message: null,
                overlayCSS: {
                    opacity: 0,
                },
            });

            const cartItemKey = $target.data('cart_item_key');
            const productId = $target.data('product_id');

            this.removeFromCart(cartItemKey)
                .then(() => {
                    const $crossSoldItem = $(
                        '.cross-sell-item [data-product="%d"]'.replace(
                            '%d',
                            productId,
                        ));

                    if (!$crossSoldItem.length) {
                        return;
                    }

                    $crossSoldItem.prop('checked', false);
                })
                .always(() => $item.css('opacity', '1')
                    .unblock(),
                );
        };

        onQuickAddToCart = (e) => {
            e.preventDefault();

            const $button = $(e.target);

            if (
                $button.parentsUntil('.action-bar')
                    .parent()
                    .hasClass('action-bar')
            ) {
                return;
            }

            if ($button.hasClass('loading')) {
                return;
            }

            $button.addClass('loading');

            const $form = $button.closest('form');

            const data = new FormData($form.get(0));

            this.addToCart(data)
                .always(() => $button.removeClass('loading'));
        };
    }

    class Single_Product_Driver extends Driver {
        constructor(actionBar) {
            super();

            this.isComposite = false;

            this.regularPrice = 0;
            this.price = 0;
            this.msrp = 0;
            this.quantity = 0;

            this.actionBar = actionBar;

            this.DOM = {
                $form: $('form.cart'),
                $crossSell: $('.cross-sells input[type="checkbox"]'),
            };

            this.actionBar.on(
                'button/click',
                this.onAddToCart,
            );

            this.DOM.$crossSell.on('change', this.onToggleCrossSoldProduct);
        }

        setPrice(regularPrice, price, msrp) {
            this.regularPrice = regularPrice;
            this.price = price;
            this.msrp = msrp;

            this.updatePrice();
        }

        setQuantity(quantity) {
            this.quantity = quantity;

            $('body').trigger('product/quantity', quantity);

            this.updatePrice();
        }

        updatePrice = () => {
            replaceProductPrices(
                this.regularPrice,
                this.price,
                this.msrp,
            );
        };

        onAddToCart = (e) => {
            e.preventDefault();

            if (this.isComposite) {
                this.prepareAddToCart();
            }

            this.actionBar.setAddToCartLoading(true);

            const data = new FormData(this.DOM.$form.get(0));

            this.addToCart(data)
                .always(() => this.actionBar.setAddToCartLoading(false));
        };

        onToggleCrossSoldProduct = e => {
            const $target = $(e.target);
            const $container = $target.closest('.cross-sell-item');

            const productId = $target.data('product');

            if ($target.is(':checked')) {
                $container.block({
                    message: null,
                    overlayCSS: {
                        opacity: 0,
                    },
                });

                const data = new FormData();
                data.append('add-to-cart', productId);
                data.append('quantity', 1);

                this.addToCart(data).always(() => $container.unblock());
            } else {
                const cartItemKey = this.getCartItemKeyFromProductId(productId);
                if (!cartItemKey) {
                    return;
                }

                $container.block({
                    message: null,
                    overlayCSS: {
                        opacity: 0,
                    },
                });

                this.removeFromCart(cartItemKey)
                    .always(() => $container.unblock());
            }
        };

        getCartItemKeyFromProductId = (id) => {
            const $cartItem = $(
                '.mini-cart .mini_cart_item [data-product_id="%d"]'
                    .replace('%d', id),
            );

            if (!$cartItem.length) {
                return '';
            }

            return $cartItem.data('cart_item_key');
        };

        closeFlyout() {
            setTimeout(() => {
                $('body').trigger('sp_flyout/hide');
            }, 100);
        }
    }

    class WooCommerce_Driver extends Single_Product_Driver {
        constructor(actionBar) {
            super(actionBar);

            this.regularPrice =
                kilamobler_add_to_cart_params.product.regular_price;
            this.msrp = kilamobler_add_to_cart_params.product.msrp_price;
            this.price = kilamobler_add_to_cart_params.product.price;
            this.quantity = kilamobler_add_to_cart_params.product.quantity;

            const product = document.querySelector('body > .product');
            if (
                product &&
                product.classList.contains('product-type-variable')
            ) {
                this.actionBar.setAddToCartDisabled(true);
            }

            this.updatePrice();

            this.DOM.$form.on(
                'found_variation',
                this.onFoundVariation,
            );

            this.actionBar.on(
                'quantity/change',
                this.onQuantityChange,
            );
        }

        onFoundVariation = (e, variation) => {
            this.actionBar.setAddToCartDisabled(false);

            this.actionBar.DOM.$quantity.attr(
                'min',
                variation.min_qty,
            );

            if (this.quantity < variation.min_qty) {
                this.setQuantity(variation.min_qty);
                this.actionBar.DOM.$quantity.val(variation.min_qty);
            }

            this.actionBar.DOM.$quantity.attr(
                'max',
                !variation.backorders_allowed
                    ? variation.max_qty
                    : '',
            );

            this.lastSelectedVariation = variation;

            this.setPrice(
                variation.regular_price,
                variation.price,
                variation.msrp_price,
            );

            this.closeFlyout();
        };

        onQuantityChange = e => {
            this.DOM.$form.find('input.qty').val(e.target.value);
            this.setQuantity(e.target.value);
        };
    }

    class Composite_Driver extends Single_Product_Driver {
        constructor(actionBar) {
            super(actionBar);

            this.isComposite = true;

            this.regularPrice = 0;
            this.price = 0;
            this.quantity = kilamobler_add_to_cart_params.product.quantity;

            $('.composite_data')
                .on(
                    'wc-composite-initializing',
                    (_, composite) => {
                        this.composite = window.composite = composite;

                        this.applyDOMOverrides();

                        composite.actions.add_action(
                            'composite_initialized',
                            this.init,
                        );
                    },
                );

            this.actionBar.on('quantity/change', this.onChangeQuantity);
        }

        applyDOMOverrides = () => {
            this.composite.$composite_quantity = $('input.qty.composite');
            this.composite.$composite_add_to_cart_button =
                $('.action-bar__cart .add-to-cart');
        };

        init = () => {
            this.composite = window.composite = composite;

            composite.actions.add_action(
                'composite_totals_changed',
                this.onCompositeTotalsChanged,
                200,
            );

            composite.actions.add_action(
                'component_selection_changed',
                this.onComponentSelectionChanged,
                200,
            );

            composite.actions.add_action(
                'available_options_changed',
                this.onAvailableOptionsChanged,
            );

            composite.filters.add_filter(
                'component_is_valid',
                this.recalculateComponentValidity,
            );

            this.onComponentSelectionChanged();
        };

        recalculateComponentValidity = (isValid, _, component) => {
            if (isValid) {
                return isValid;
            }

            if (!component.is_optional() && !component.get_selected_product()) {
                // This will be fixed later.
                isValid = true;
            }

            return isValid;
        };

        onAvailableOptionsChanged = component => {
            if (component.is_optional() || component.get_selected_product()) {
                return;
            }

            const options = component
                .component_options_model
                .available_options_data;

            if (options.length > 0) {
                component.$component_options_select
                    .val(options[0].option_id)
                    .trigger('change');
            }
        };

        onCompositeTotalsChanged = () => {
            this.updatePrices();

            const totals = this.composite.api.get_composite_totals();

            if (window.ingrid_product_page_widget_params) {
                window.ingrid_product_page_widget_params.viewed_item = {
                    ...window.ingrid_product_page_widget_params.viewed_item,
                    price: Math.round(totals.price * 100),
                };
            }

            $(document).trigger('found_variation');
        };

        onComponentSelectionChanged = () => {
            this.actionBar.setAddToCartDisabled(
                !composite.composite_add_to_cart_button_view.model.get_validation_status(),
            );

            this.closeFlyout();
        };

        onChangeQuantity = (e) => {
            if (this.composite.$composite_quantity.length === 0) {
                return;
            }

            this.composite.$composite_quantity.val(e.target.value);
            this.setQuantity(e.target.value);
        };

        updatePrices = () => {
            const totals = this.composite.api.get_composite_totals();
            this.setPrice(totals.regular_price, totals.price, 0);
        };

        prepareAddToCart = () => {
            const model = this.composite.composite_add_to_cart_button_view.model;

            if (!model.get('passes_validation') || !model.get('is_in_stock')) {
                window.alert(wc_composite_params.i18n_validation_issues);
                return false;
            }

            for (
                let step_index = 0, steps = composite.get_steps(), length = steps.length;
                step_index < length;
                step_index++
            ) {
                let step = steps[step_index];

                step.$el.find('select, input').each(function() {
                    $(this).prop('disabled', false);
                });

                if (!step.is_component()) {
                    continue;
                }

                let has_addons = step.has_addons();

                if (!has_addons) {

                    if ('bundle' === step.get_selected_product_type()) {

                        let bundle = step.get_bundle_script(step.component_id);

                        if (bundle) {

                            $.each(
                                bundle.bundled_items,
                                function(index, bundled_item) {

                                    if (bundled_item.has_addons()) {
                                        has_addons = true;
                                        return false;
                                    }

                                },
                            );
                        }
                    }
                }

                if (has_addons) {
                    step
                        .$component_summary_content.find(
                            '.wc-pao-required-addon [required]',
                        )
                        .prop('required', false);
                }

                if (false ===
                    step.step_visibility_model.get('is_visible')) {
                    step.$component_summary_content.append(
                        '<input name="wccp_component_selection_nil[' +
                        step.step_id +
                        ']" value="1"/>');
                }
            }

            return true;
        };
    }

    new Add_To_Cart();
});
